import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DetailItem } from 'components';
import { renderClientName } from 'utils';

export const SessionDetails = ({}) => {
    const sessionById = useSelector((state) => state.session.sessionById);

    return (
        <div style={{ width: 800 }}>
            <p className="modal-header-title">Session Details</p>
            <div style={{ marginTop: 16 }}>
                <DetailItem title={'Session D/T'} value={moment(sessionById?.startDate).format('LLLL')} />
                <DetailItem title={'Service'} value={sessionById?.appt?.serviceName} />
                <DetailItem title={'Client'} value={renderClientName(sessionById?.appt?.client)} />
            </div>
        </div>
    );
};
